import React from 'react';
import { DisplayValue } from '../Models/Valg';

export function RadioButtonDisplay(gruppe: string, value: DisplayValue): JSX.Element {
    const id = `${gruppe}-svar-visning`;
    return (
        <div className="c-veileder__valgt-item">
            <span className="c-veileder__tekst c-veileder__tekst--valg" id={id}>
                {value.displayValue}
            </span>
        </div>
    );
}

export function NumberInputDisplay(gruppe: string, value: DisplayValue): JSX.Element {
    const id = `${gruppe}-svar-visning`;
    return (
        <div className="c-veileder__valgt-item">
            <span className="c-veileder__tekst c-veileder__tekst--valg" id={id}>
                {value.displayValue}
            </span>
        </div>
    );
}
